import {
   ReceptionServiceWithPractitionersSimple,
   ReceptionServiceWithPractitionersSimpleQuery,
} from '@dreryk/egabinet-private-medical-service-frontend-api';

import { CqrsQueryPerformResult, performCqrsQuerySearch } from '@dreryk/command-query-react-common';
import { TextPattern } from '@dreryk/watermelon';

export const searchCreator = (searchText: string | null) => {
   return async (): CqrsQueryPerformResult<ReceptionServiceWithPractitionersSimple[]> =>
      performCqrsQuerySearch<ReceptionServiceWithPractitionersSimple>(() => {
         const query = new ReceptionServiceWithPractitionersSimpleQuery();
         query.name = searchText ? TextPattern.anywhereIgnoreCase(searchText) : TextPattern.any();
         return query;
      });
};

export const triggerLabelExtractor = (receptionService: ReceptionServiceWithPractitionersSimple): string =>
   receptionService.name;
